import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between py-1 text-lg font-bold text-white bg-primary px-7" }
const _hoisted_2 = { key: 0 }

import { useScorecardStore } from '@/store/scorecards';
import {
  Briefcases,
  Match,
  MatchResponse,
  ScorecardDisplayState,
  ScorecardStatus,
  ScorecardViewMode,
  Tables,
  Unscheduled,
} from '@/typings/scorecard';
import { User } from '@/typings/user';
import { computed, inject, toRefs } from 'vue';
import { useRouter } from 'vue-router';

interface Props {
  user: User | null;
  viewing?: string;
  unsavedChanges: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    viewing: null,
    unsavedChanges: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  user: User | null;
  viewing?: string;
  unsavedChanges: boolean;
}

const scorecardStore = useScorecardStore();



function getMatchStatus(match: Match, matchResponse: MatchResponse) {
  if (resultsMode) {
    return '';
  }
  if (scorecardStore.displayState === ScorecardDisplayState.View) {
    return matchResponse.Score.toString();
  }

  try {
    const questions = matchResponse.Questions;
    let answers = 0;
    if (!matchResponse.Answer && match.HasWinner) return 'Incomplete';
    const len = matchResponse.Answer.toString().trim().length;
    if (len > 0) {
      answers += 1;
    }
    for (let i = 0; i < questions.length; i += 1) {
      if (
        questions[i].Answer !== null &&
        questions[i].Answer.toString().trim().length > 0
      ) {
        answers += 1;
      }
    }

    if (answers === 0) {
      return 'Incomplete';
    }
    if (answers === questions.length + (match.HasWinner ? 1 : 0)) {
      return 'Complete';
    }
  } catch (e) {
    console.error(e);
  }
  return 'In Progress';
}

function getBriefcaseStatus(briefcases: Briefcases) {
  let total = 0;
  for (let i = 0; i < briefcases.length; i += 1) {
    if (briefcases[i] !== '-1') {
      total += 1;
    }
  }

  if (total === 0) {
    return 'Incomplete';
  }
  if (total === briefcases.length) {
    return 'Complete';
  }
  return 'In Progress';
}

function getUnscheduledStatus(unscheduled: Unscheduled, limit: number) {
  let total = 0;
  for (let i = 0; i < unscheduled.length; i += 1) {
    try {
      if (unscheduled[i] !== '-1') {
        total += 1;
      }
    } catch {
      // ..
    }
  }

  if (total === 0) {
    return 'Incomplete';
  }
  if (total === limit) {
    return 'Complete';
  }
  return 'In Progress';
}

function getTableStatus(tables: Tables) {
  let total = 0;
  for (let i = 0; i < tables.length; i += 1) {
    if (tables[i] !== '0') {
      total += 1;
    }
  }

  if (total === 0) {
    return 'Incomplete';
  }
  if (total === tables.length) {
    return 'Complete';
  }
  return 'In Progress';
}

const status = computed(() => {
  if (resultsMode) {
    return 'Results Card';
  }

  if (!scorecardStore.scorecard) return '';

  const { event, usersAnswers } = scorecardStore.scorecard;
  if (!event || event.Status === 'Scheduled') {
    return '';
  }

  if (event.Status !== ScorecardStatus.Open) {
    return (usersAnswers?.Score || 0).toString();
  }

  const statuses: string[] = [];

  if (event.Briefcases.length) {
    statuses.push(getBriefcaseStatus(usersAnswers.Briefcases));
  }

  if (event.Tables.length) {
    statuses.push(getTableStatus(usersAnswers.Tables));
  }

  if (event.Unscheduleds) {
    statuses.push(
      getUnscheduledStatus(usersAnswers.Unscheduled, event.Unscheduleds)
    );
  }

  for (const match of event.Matches) {
    const userResponse = usersAnswers.Matches.find(
      (m) => m.MatchId === match.MatchId
    );
    if (!userResponse) continue;
    statuses.push(getMatchStatus(match, userResponse));
  }

  if (props.unsavedChanges) {
    return 'UNSAVED';
  }

  const results = statuses.reduce(
    (prev, curr) => {
      switch (curr) {
        case 'Incomplete':
          prev.incomplete += 1;
          break;
        case 'Complete':
          prev.complete += 1;
          break;
        case 'In Progress':
          prev.inProgress += 1;
          break;
        default:
          break;
      }
      return prev;
    },
    {
      incomplete: 0,
      complete: 0,
      inProgress: 0,
    }
  );

  if (results.incomplete === 0 && results.inProgress === 0) {
    return 'Complete';
  }
  if (results.inProgress > 0 && results.incomplete >= 0) {
    return 'In Progress';
  }
  return 'Not Started';
});

const { viewing } = toRefs(props);

const resultsMode = inject('resultsMode');
const viewMode = inject('viewMode');
const router = useRouter();

function onOpenAccount() {
  if (viewing && viewing.value) {
    router.push({
      name: 'AccountUser',
      params: {
        user: viewing.value,
      },
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(viewMode) === _unref(ScorecardViewMode).Public)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Results"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: onOpenAccount
          }, _toDisplayString(_unref(viewing) || __props.user?.Name), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(status)), 1)
        ], 64))
  ]))
}
}

})